import { empty } from "@";
import { memo } from "react";

const Nodata = ({ size = 70, font = "text-base font-bold" }) => {
  return (
    <div className="flex flex-col items-center justify-center gap-3 pb-10 pt-6 text-center">
      <span className="relative inline-flex items-center justify-center">
        {/* Soft halo */}
        <span
          aria-hidden
          className="absolute inset-0 -z-0 mx-auto rounded-full bg-gradient-to-br from-purple-200/40 via-purple-100/30 to-transparent blur-2xl dark:from-purple-700/30 dark:via-purple-900/30"
          style={{ width: size * 1.6, height: size * 1.6 }}
        />
        <img
          className="relative dark:opacity-70 dark:contrast-50 dark:grayscale dark:filter"
          src={empty}
          width={size}
          height={size}
          alt="empty"
        />
      </span>
      <h1 className={`${font} tracking-tight text-gray-700 dark:text-gray-300`}>
        لا توجد بيانات لعرضها
      </h1>
      <p className="text-xs text-gray-400 dark:text-gray-500">
        جرّب تعديل الفلاتر أو إضافة عناصر جديدة
      </p>
    </div>
  );
};

export default memo(Nodata);
